import React from 'react';
import { useSelector } from 'react-redux';
import ReactI18n from 'react-i18n';
import {
  Box,
  PageStateMessage,
  Spacer,
  TextH2
} from '@directsoftware/ui-kit-web-admin';
import { selectCheckoutState } from '../../../redux/slices/checkout';
import CheckoutPricingInfo from './checkout-pricing-info';
import { availabilityErrorText } from '../../../utils/wls-booking-range';

const CheckoutMobilePricing = ({ updateCheckoutState }) => {
  const checkoutState = useSelector(selectCheckoutState);
  const translate = ReactI18n.getIntlMessage;

  return !checkoutState.availabilityLoading ? (
    <>
      <TextH2>Your Total</TextH2>
      <Spacer size="xs" />
      {checkoutState.availability?.bookable && checkoutState.pricing ? (
        <CheckoutPricingInfo updateCheckoutState={updateCheckoutState} />
      ) : (
        <Box padding="l">
          {availabilityErrorText(checkoutState.availability, translate)}
        </Box>
      )}
      <Spacer size="l" />
    </>
  ) : (
    <PageStateMessage iconProps={{ name: 'spinner', spin: true }} />
  );
};

export default CheckoutMobilePricing;
